export const NAMESPACE = 'KanBo/heartbeats/'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_LOCATION_STATE = NAMESPACE + 'SET_LOCATION_STATE'

const initialState = []

const heartbeatDefaults = {
  userId: null,
  location: null,
  action: null,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD: {
      switch (action.payload.action) {
        case 'Enter':
        case 'Being':
          return [
            ...state.filter(heartbeat =>
              heartbeat.userId !== action.payload.userId ||
              heartbeat.location !== action.payload.location ||
              heartbeat.action !== 'Being'
            ),
            {
              ...heartbeatDefaults,
              ...action.payload,
              action: 'Being'
            }
          ]
        case 'Leave':
          return state.filter(heartbeat =>
            heartbeat.userId !== action.payload.userId ||
            heartbeat.location !== action.payload.location ||
            heartbeat.action !== 'Being'
          )
        case 'StartEdit':
        case 'Editing':
          return [
            ...state.filter(heartbeat =>
              heartbeat.userId !== action.payload.userId ||
              heartbeat.location !== action.payload.location ||
              heartbeat.action !== 'Editing'
            ),
            {
              ...heartbeatDefaults,
              ...action.payload,
              action: 'Editing'
            }
          ]
        case 'StopEdit':
          return state.filter(heartbeat =>
            heartbeat.userId !== action.payload.userId ||
            heartbeat.location !== action.payload.location ||
            heartbeat.action !== 'Editing'
          )
        default: return state
      }
    }
    case REMOVE:
      return state.filter(heartbeat =>
        heartbeat.userId !== action.payload.userId ||
        heartbeat.location !== action.payload.location ||
        heartbeat.action !== action.payload.action
      )
    case SET_LOCATION_STATE: {
      return [
        ...state.filter(heartbeat =>
          heartbeat.location !== action.payload.location
        ),
        ...action.payload.state
      ]
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function remove ({ userId, location, action }) {
  return {
    type: REMOVE,
    payload: {
      userId,
      location,
      action
    }
  }
}

export function setLocationState ({
  location,
  state
}) {
  return {
    type: SET_LOCATION_STATE,
    payload: {
      location,
      state
    }
  }
}
